<template>
  <v-container id="unknown-passenger-info">
    <c-card title="회원 조회 및 정보 입력" class="mt-12">
      <template #headItems>
        <c-btn outlined color="green" @click="registerCustomerDialog = true">신규회원등록</c-btn>
      </template>

      <v-row align="center" justify="center">
        <v-col cols="8" class="text-center">
          <v-menu style="display: inline-block"
                  v-model="input.showCustomerList"
                  :close-on-content-click="true"
                  offset-y
                  nudge-top="30">
            <template #activator="{ on }">
              <!--NOTE keypress사용? keyup.enter 사용시 이벤트가 두번 트리거되는 이슈 발생.(한글입력시에만 발생) -->
              <v-text-field class="d-inline-block mx-2" label="회원 이름" v-model="input.name" @keypress.enter="reqSearchPassenger"></v-text-field>
              <v-text-field class="d-inline-block mx-2" label="전화번호 뒷자리" v-model="input.lastNumber" @keypress.enter="reqSearchPassenger" maxlength="4"></v-text-field>
            </template>
            <v-list>
              <v-list-item
                  v-for="(item, index) in input.customerSearchList"
                  :key="index"
                  @click="onSelectPassenger(item)">
                <v-list-item-title>{{ item.name }}  {{item.mobileNo}}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <c-btn outlined color="blue" @click="reqSearchPassenger" class="d-inline-block mx-2">회원조회</c-btn>
        </v-col>
      </v-row>
    </c-card>

    <c-card title="미예약자 목록">
      <template #headItems>
        <h3 class="blue--text" style="min-width: 60px">총 {{input.passengerList.length}} 명</h3>
      </template>
      <span class="red--text">*</span><span>는 필수입력항목입니다.</span>

      <c-table :headers="passengerTableHeaders" :items="input.passengerList" hide-default-footer class="mt-3">
        <template #order="{item}">
          {{input.passengerList.indexOf(item)+1}}
        </template>
        <template #passengerType="{item}">
          {{$func.displayPassengerType(item.passengerType)}}
        </template>
        <template #customerName="{item}">
          {{item.customerName? item.customerName : '-'}}
        </template>
        <template #customerNo="{item}">
          {{item.customerNo? item.customerNo : '-'}}
        </template>
        <template #customerType="{item}">
          {{item.customerType ? $func.displayCustomerType(item.customerType) : '비회원'}}
        </template>
        <template #etc="{item}">
          {{$func.displayWeakCustomerInfo(item.mobilityWeakInfo, item.pregnantInfo)}}
        </template>
        <template #usages="{item}">
          <span v-if="!item.customerId">미확인</span>
          <v-select
              v-else
              v-model="item.usages"
              :items="centerUseList"
              placeholder="용도"
              dense>
          </v-select>
        </template>
        <template #luggage ="{item}">
          <v-row align="center">
            <span v-if="!item.customerId">없음</span>
            <v-select
                v-else
                v-model="item.luggage"
                :items="centerLuggageList"
                align="center"
                placeholder="수하물"
                item-text="label"
                multiple
                dense
                small-chips
                deletable-chips
                item-color="blue">
            </v-select>
            <v-text-field
                v-if="inputExtraLuggage(item.luggage)"
                v-model="item.selectedLuggageInput"
                label="직접 입력"
                maxlength="256" style="width: 90px; padding-top: 5px;"
                dense>
            </v-text-field>
          </v-row>
        </template>

        <template #detail="{item}">
          <c-btn icon iconName="search" @click="showCustomerInfoDlg(item)" v-if="item.customerId">
          </c-btn>
        </template>
        <template #delete="{item}">
          <c-btn icon iconName="mdi-close"  @click="removePassenger(input.passengerList.indexOf(item))"></c-btn>
        </template>
      </c-table>

      <v-row align="center" justify="center" class="mt-10">
        <c-btn outlined color="blue" class="mx-1" @click="updatePassengers">수정</c-btn>
        <c-btn outlined color="grey" class="mx-1" @click="cancelUpdatePassengers">취소</c-btn>
      </v-row>

    </c-card>

    <customer-c-u-dialog :open.sync="registerCustomerDialog" @reqAddCustomer="reqAddCustomer">
    </customer-c-u-dialog>

    <customer-info-dialog
        :open.sync= "input.showCustomerInfoDialog"
        :customerInfo = "input.showCustomerInfo"
        :voucherInfo = "input.customerVoucherInfo"
        :groupInfo = "input.groupInfo"
    ></customer-info-dialog>
  </v-container>
</template>

<script>
import CustomerInfoDialog from "@/views/CallTaxi/Reserve/CustomerInfoDialog";
import CustomerCUDialog from "@/views/Default/Customer/CustomerCUDialog";

export default {
  name: "UnknownPassengerInfo",
  components:{CustomerInfoDialog, CustomerCUDialog},
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
    reservedPassengers: {
      type: Object
    },
    unknownPassengers:{
      type: Object
    }
  },
  data() {
    return {
      registerCustomerDialog : false,
      centerLuggageList: this.$store.state.luggageList,
      centerUseList: this.$store.state.centerInfo.useList.split(','),
      input: {
        name: '',
        lastNumber: '',
        customerSearchList: [],
        passengerList: [],
        showCustomerList : false,
        showCustomerInfo: {},
        selectedUseInput : '',
        showCustomerInfoDialog : false,
        customerDetailInfo : [],
        customerVoucherInfo : [],
        groupInfo : [],
      },
      default: {
      },
      passengerTableHeaders:[
        {text:'No.', value:'order', align:'center'},
        {text:'구분', value:'passengerType', align:'center'},
        {text:'이름', value:'customerName', align:'center'},
        {text:'연락처', value:'customerNo', align:'center'},
        {text:'회원 유형', value:'customerType', align:'center'},
        {text:'비고', value:'etc', align:'center'},
        {text:'용도', value:'usages', align:'center', required: true},
        {text:'수하물', value:'luggage', align:'center', required: true},
        {text:'상세보기', value:'detail', align:'center'},
        {text:'', value:'delete', align:'center'},
      ],
    }
  },
  watch: {
    clear(value) {
      if(!value) {
        this.initData();
        this.$emit('update:clear', false)
      }
    },
    unknownPassengers(value) {
      this.input.passengerList = value;
    }
  },
  async created(){
    await this.initData();
    this.input.passengerList = this.unknownPassengers;
  },
  methods:{
    inputExtraLuggage(luggage) {
      if (luggage === null || luggage === undefined){
        return false;
      }

      return (luggage.length > 0 && luggage.indexOf(-1) > -1) ? true : false;
    },
    initCustomerInfo() {
      this.input.name='';
      this.input.lastNumber='';
      this.input.customerSearchList = [];
    },
    async reqAddCustomer(data) {
      try {
        await this.$api.addCustomer(data);
        this.initCustomerInfo();
        this.registerCustomerDialog = false;
      } catch (err) {
        this.$store.commit('snackbar', {err, where:'reqAddCustomer'});
      }
    },
    async reqSearchPassenger() {
      try {
        const name = this.input.name;
        const lastNumber = this.input.lastNumber;

        if(!name && !lastNumber) {
          this.$store.commit('snackbar', {msg:'회원 이름 또는 전화번호 뒷자리를 입력해주세요.'});
          return;
        }
        const res = await this.$api.getCustomerInfoByNameOrLastNumber(name, lastNumber);
        this.initCustomerInfo();
        if(res.data.length === 1) {
          const passenger = res.data[0];
          this.setPassengerList(passenger);
        } else {
          this.input.showCustomerList = true;
          this.input.customerSearchList = [...res.data];
        }

      } catch(err) {
        this.$store.commit('snackbar', {err, where:'reqSearchPassenger'});
      }
    },
    onSelectPassenger(passenger) {
      this.input.showCustomerList = false;
      this.setPassengerList(passenger);
    },
    setPassengerList(passenger) {
      const isNotExist = this.checkPassengerDuplicate(passenger);
      if(!isNotExist) { return;}

      this.input.passengerList.push({
        ...passenger,
        customerName: passenger.name,
        customerNo: passenger.mobileNo,
        usages : this.centerUseList[0],
        luggage : ['없음'],
        selectedLuggageInput : '',
        selectedUseInput : '',
        customerId: passenger.id,
      });
    },
    cancelUpdatePassengers() {
      this.clear= false;
    },
    initData() {
      this.input = this.$func.initObjectData(this.input, this.default);
    },
    checkPassengerDuplicate(passenger) {
      const allPassengers = this.input.passengerList.concat(this.reservedPassengers);
      for (const passengerListElement of allPassengers) {
        if (passengerListElement.customerId === passenger.id) {
          this.$store.commit('snackbar', {msg:'입력하신 회원은 탑승자 정보에 존재합니다.'});
          return false;
        }
      }
      return true;
    },
    showCustomerInfoDlg(item) {
      this.input.showCustomerInfoDialog = true;
      this.input.showCustomerInfo = item;
      this.reqGetVoucher(item.id);
      this.reqGetJoinedGroupDetailList(item.id);
    },
    async reqGetJoinedGroupDetailList(customerId) {
      try {
        const res = await this.$api.getJoinedGroupDetailList(customerId);

        this.input.groupInfo = res.data.map(item => {
          item.groupName = item.groupInfo.name;
          item.type = item.groupInfo.type.configName;
          item.memberCnt = item.groupInfo.memberCnt;
          return item;
        });
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'reqGetJoinedGroupDetailList'});
      }
    },
    async reqGetVoucher(cId) {
      const res = await this.$api.getCustomerVoucher(cId);
      let remainCnt = 0;
      let useCnt = 0;
      let issueCnt = 0;
      let backCnt = 0;
      for (let idx in res.data) {
        remainCnt += Number(res.data[idx].remainCnt);
        useCnt += Number(res.data[idx].useCnt);
        issueCnt += Number(res.data[idx].issueCnt);
        backCnt += Number(res.data[idx].backCnt);
      }

      this.input.customerVoucherInfo = {
        remainVoucher : remainCnt,
        useVoucher : useCnt,
        issueVoucher : issueCnt,
        backVoucher : backCnt
      };
    },
    removePassenger(index) {
      this.input.passengerList.splice(index, 1);
    },
    updatePassengers() {
      try {
        const isValidInfo = this.validatePassengerInfo();
        let passengerReq = [];
        if(isValidInfo) {
          for(const passenger of this.input.passengerList) {
            if(!passenger.customerId) {
              continue;
            }
            else if(passenger.luggage.indexOf(-1) >= 0) {
              const index = passenger.luggage.indexOf(-1);
              passenger.luggage[index] = passenger.selectedLuggageInput
            }
            passengerReq.push(
                {customerId : passenger.customerId, passengerType: 'UNKNOWN', usages: passenger.usages, luggage: passenger.luggage.join()}
            )
          }

          let originRiderCount = this.reservedPassengers.filter(item=> item.passengerType !== 'UNKNOWN' && item.isBoarded ===true).length
          const request = {
            driveLogId : this.$route.params.id,
            passengerDtos: passengerReq,
            riderCount: originRiderCount + this.input.passengerList.length,
          }
          this.reqUpdatePassengers(request);
        }
      } catch (err) {
        this.$store.commit('snackbar', {err, where: 'updatePassengers'});
      }
    },
    async reqUpdatePassengers(request) {
      const res = await this.$api.updateUnknownPassengers(request);
      this.clear = false;
    },
    validatePassengerInfo() {
      for(const passenger of this.input.passengerList) {
        if(!passenger.customerId) {
          continue;
        }
        if(passenger.luggage.length < 1) {
          this.$store.commit('snackbar', {msg: '수하물 정보를 입력해주세요.'});
          return false;
        }
      }
      return true;
    }
  },
}
</script>

<style scoped>

</style>